<template>
  <headers />
 
  <div class="info">
    <h3>学生住宿信息确认表</h3>
    <form
      class="el-form demo-table-expand el-form--label-left el-form--inline"
      :model="ruleForm.datas"
    >
      <el-divider content-position="left"><h4>学生信息</h4> </el-divider>

      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学号：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_No
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">姓名：</label>

          <label class="el-form-item__text">{{
            ruleForm.datas.student_Name
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">拼音码：</label>

          <label class="el-form-item__text">{{
            ruleForm.datas.student_Name_Spell
          }}</label>
        </el-col>

        <el-col :span="6" :lg="6" :xs="12">
          <el-image
            :src="ruleForm.datas.student_Photo"
            style="
              margin: 10px auto;
              float: right;
              height: 150px;
              width: 120px;
              position: absolute;
              right: 6%;
            "
          >
          </el-image>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">身份证：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_IDnumber
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">性别：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Sex
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">生日：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Birthday
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学生类型：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Type
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">手机号：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Mobile
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">年级：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Grade
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学制：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Years
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">民族：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_mz
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">政治面貌：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Zzmm
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">入学时间：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Entrance_DateStr
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">毕业时间：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Leave_DateStr
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">邮箱：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Email
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">院系：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Dept
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">专业：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Specialty
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">班级：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Class
          }}</label>
        </el-col>
      </el-row>
       <el-row :gutter="20">
        <el-col :span="24" :lg="24" :xs="24">
          <label class="el-form-item__labelright">备注：</label>
          <label class="el-form-item__text1">
           {{ruleForm.datas.student_Memo}}</label>
        </el-col>
      </el-row>
      <el-divider content-position="left"><h4>家庭信息</h4> </el-divider>
      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">父/母姓名：</label>
          <label class="el-form-item__text3">
           {{ruleForm.datas.student_Home_Parents}}
          </label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">籍贯：</label>
          <label class="el-form-item__text3">
            {{ruleForm.datas.student_NativePlace}}</label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">家庭电话：</label>
          <label class="el-form-item__text3">
            {{ruleForm.datas.student_Home_Mobile}}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">家庭地址：</label>
          <label class="el-form-item__text3">
           {{ruleForm.datas.student_Home_address}}
          </label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">邮编：</label>
          <label class="el-form-item__text3">
            {{ruleForm.datas.student_Home_Code}}
          </label>
        </el-col>
      </el-row>
      <el-divider content-position="left"><h4>住宿信息</h4></el-divider>
        <el-row :gutter="20">
       <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">公寓：</label>

          <label class="el-form-item__text3">{{
            ruleForm.datas.student_BuildingName
          }}</label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">房间：</label>

          <label class="el-form-item__text3">{{
            ruleForm.datas.student_Room
          }} 房间</label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">床位：</label>

          <label class="el-form-item__text3">{{
            ruleForm.datas.student_Cwname 
          }} 号床位</label>
        </el-col>
      </el-row>
     
      <!-- <el-divider content-position="left"><h4>您的同房间舍友</h4></el-divider>
       <el-table
      :data="ruleForm.Roomlist"
      style="width: 100%">
      <el-table-column
        prop="cw_Name" align="center"
        label="床位号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="cw_type" align="left"
        label=""
        width="100">
      </el-table-column>
      <el-table-column
        prop="student_Name"
        label="姓名"
        width="180">
      </el-table-column>
       <el-table-column
        prop="student_mz"
        label="民族"
        width="180">
      </el-table-column>
      <el-table-column
        prop="zsfp_TypeName"
        label="专业">
      </el-table-column>
      <el-table-column
        prop="student_Habits"
        label="生活习惯">
      </el-table-column>
    </el-table> -->
    </form>
        <el-row class="print-row">
         <el-col  :span="8" :lg="8"></el-col>
         <el-col  :span="8" :lg="8">
          <el-button class="el-button-cuc el-button-print"  @click="doPrint()"
          >点击打印《中国传媒大学学生公寓住宿信息表》</el-button></el-col>
          <el-col :span="8" :lg="8">
      </el-col>
      </el-row>
      <div
        v-if="hasReadAgreement"
        class="login-copyright"
        v-html="ruleForm.type12.description"
      ></div>
     
  </div>
  

  <el-dialog
    v-model="agreementDialogVisible"
    width="70%"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="false"
  >
    <div
      ref="agreementContentRef"
      class="agreement-content"
      @scroll="onAgreementScroll"
      v-html="ruleForm.type4.description"
    ></div>
    <template #footer>
      <el-button
        type="primary"
        :disabled="!agreementCanClose || !agreementScrolledToEnd"
        @click="confirmAgreement"
      >
        {{
          agreementCanClose
            ? agreementScrolledToEnd
              ? "我已阅读,前往打印"
              : `请下拉认真阅读全部内容`
            : `请下拉认真阅读全部内容 ${info.xieyinumber}`
        }}
      </el-button>
    </template>
  </el-dialog>

</template>
<style lang="scss" scoped>
.agreement-content {
  max-height: 50vh;
  overflow-y: auto;
  line-height: 1.8;
  color: #303133;
  
}

.print-row {
  text-align: center;
}

.print-row .el-col {
  text-align: center;
}

.print-row .el-button-print {
  float: none;
  margin: 30px 0 0 auto;
  display: inline-block;
  width: 400px;
  height: 42px;
  line-height: 22px;
  padding: 8px 0;
}

.login-copyright {
            color: #000;
            text-align: center;
            position: relative;
            z-index: 1;
            margin:50px 0;
        }
.el-form-item__text {
  text-align: left;
  width: 70%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__text3 {
  text-align: left;
  width: 75%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__text1 {
  text-align: left;
  width: 92%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__labelright {
  text-align: right;
  width: 90px;
  color: #080808;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-form-item {
  margin-bottom: 0px;
}
.info {
  width: 98%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 50px;
}
.el-button-cuc,.el-button-cuc:hover,.el-button-cuc:focus{
  float: left;
	background-image:none;
	background-color:#059490;
	width: 400px;
	line-height: 1;
	padding:8px 0;
	cursor: pointer;
	border:1px solid #04726f;
	font-family:"Microsoft YaHei";
	font-size:16px;
	height:50px;
	border-radius:6px;
	margin: 30px 0 0 auto;
	color:#fff;
	text-align:center;
	position:relative;
	box-sizing: border-box;
}
</style>
<script>
import headers from "../views/Home.vue";
import { getStudent } from "../http/api.ts";
import { getRoomStudent } from "../http/api.ts";
import { getInfoBaseByType } from "../http/api.ts";
import { GetWebSiteSet } from "../http/api.ts";
import { reactive } from "vue";
import { ref } from "vue";
import { nextTick } from "vue";
import Route from "../router/index";
export default {
  components: {
    headers,
  },
  setup() {
    let imgs = reactive("../../images/logo.png");
    let ruleForm = reactive({
      datas: [],
      Roomlist: [],
      type12: {},
      type4: {},
    });
    let agreementDialogVisible = ref(false);
    let hasReadAgreement = ref(false);
    let agreementCanClose = ref(false);
    let agreementScrolledToEnd = ref(false);
    let agreementContentRef = ref(null);
    let info = reactive({
      xieyinumber: 0,
    });
    let agreementClock = null;
    let dataFun = async () => {
      await getStudent().then((res) => {
        ruleForm.datas = res.datas;
      });
      await getRoomStudent(ruleForm.datas.student_Room_Serial,ruleForm.datas.student_Grade).then((res) => {
        ruleForm.Roomlist = res.datas;
      });
       await getInfoBaseByType("12").then((res) => {
        ruleForm.type12 = res.datas;
      });
      await getInfoBaseByType("13").then((res) => {
        ruleForm.type4 = res.datas || { description: "" };
      });
    };
    let clearAgreementClock = () => {
      if (agreementClock) {
        window.clearInterval(agreementClock);
        agreementClock = null;
      }
    };
    let startAgreementCountDown = async () => {
      clearAgreementClock();
      agreementCanClose.value = false;
      await GetWebSiteSet().then((res) => {
        info.xieyinumber = Number(res.datas.xieyinumber);
      });
      if (!Number.isFinite(info.xieyinumber) || info.xieyinumber < 1) {
        info.xieyinumber = 1;
      }
      agreementClock = setInterval(() => {
        info.xieyinumber--;
        if (info.xieyinumber <= 0) {
          info.xieyinumber = 0;
          agreementCanClose.value = true;
          clearAgreementClock();
        }
      }, 1000);
    };
    let openAgreementDialog = async () => {
      agreementDialogVisible.value = true;
      agreementScrolledToEnd.value = false;
      await nextTick();
      let el = agreementContentRef.value;
      if (el && el.scrollHeight <= el.clientHeight + 2) {
        agreementScrolledToEnd.value = true;
      }
      await startAgreementCountDown();
    };
    let onAgreementScroll = () => {
      let el = agreementContentRef.value;
      if (!el || agreementScrolledToEnd.value) {
        return;
      }
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
        agreementScrolledToEnd.value = true;
      }
    };
    let confirmAgreement = () => {
      if (!agreementCanClose.value) {
        return;
      }
      hasReadAgreement.value = true;
      agreementDialogVisible.value = false;
      clearAgreementClock();
    };
    dataFun().then(() => {
      if (!hasReadAgreement.value) {
        openAgreementDialog();
      }
    });
    return {
      ruleForm,
      imgs,
      agreementDialogVisible,
      hasReadAgreement,
      agreementCanClose,
      agreementScrolledToEnd,
      agreementContentRef,
      info,
      openAgreementDialog,
      onAgreementScroll,
      confirmAgreement,
    };
  },
  methods: {
    onSubmit(ruleForm) {
      console.log(ruleForm.student_Memo);
    },doPrint(){
      Route.push('print?tmsite='+Math.random());
    },DownPrint(){
      
    }
  },
};
</script>